var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu"},[_c('MenuPC',{attrs:{"m-items":_vm.menuItems}}),_vm._v(" "),_c('MenuSP',{attrs:{"m-items":_vm.menuItemsSP}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }